<div #portalMessageEditorReactContainer style="height: 100%"></div>